import React from "react"
import { BsPersonFillExclamation } from "react-icons/bs"

type CommentProps = {
  expanded?: boolean
  text: string
  children?: React.ReactNode
  className? : React.ReactNode
}

export const Comment = ({ expanded = true, text, children, className }: CommentProps) => (
  <div className={`comment bg-warning-subtle text-dark ${className} ${expanded ? 'expanded' : ''}`}>
    {children ? <div className="tejxt-end">{children}</div> : null}
    <div className="comment-text">
      <BsPersonFillExclamation style={{ fontSize: '1.4em' }} />&nbsp;&nbsp;{text}
    </div>
  </div>
)

export default Comment
